import ApiService from "../../common/apiService";
import { getData } from "../../common/dataHelper";
import { LAST_VIDEOS_TYPES } from "../types";
const state = {
    courses: [],
};

const getters = {
    [LAST_VIDEOS_TYPES.GET_LAST_VIDEOS](state) {
        return state.courses;
    },
};

const actions = {
    async [LAST_VIDEOS_TYPES.FETCH_LAST_VIDEOS]({ commit }) {
        const response = await ApiService.query("academy/videos");
        const courses = getData(response, "data.courses");
        if (courses) {
            commit(LAST_VIDEOS_TYPES.SET_LAST_VIDEOS, courses);
        }
        return response;
    },
};

const mutations = {
    [LAST_VIDEOS_TYPES.SET_LAST_VIDEOS](state, array) {
        state.courses = array;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
